import axios from 'axios';
import { UpdateScenarioCageDataInput } from 'views/bluviu-nutrition/features/scenarios-v2/types/update-scenario-cage-data-input.type';
import { ScenarioCageData } from 'views/bluviu-nutrition/features/scenarios-v2/types/scenario-cage-data.type';
import { UpdateScenarioFeedProgramInput } from 'views/bluviu-nutrition/features/scenarios-v2/types/update-scenario-feed-program-input.type';
import { UpdateScenarioFinancialDataInput } from 'views/bluviu-nutrition/features/scenarios-v2/types/update-scenario-financial-data-input.type';
import { UpdateScenarioOverviewInput } from 'views/bluviu-nutrition/features/scenarios-v2/types/update-scenario-overview-input.type';
import { Scenario } from 'views/bluviu-nutrition/features/scenarios-v2/types/scenario.type';

// /ewosapi/v1/scenarios/gt2-multi/{scenarioId}/cage-data
export const putScenarioCageData = async (
  scenarioId: string,
  globalSiteId: string,
  cageData: UpdateScenarioCageDataInput
): Promise<ScenarioCageData[]> => {
  const result = await axios.put(`/ewosapi/v1/scenarios/gt2-multi/${scenarioId}/cage-data?globalSiteId=${globalSiteId}`, cageData);
  return result.data;
};

export const putSetupOverview = async (
  scenarioId: string,
  globalSiteId: string,
  data: UpdateScenarioOverviewInput
): Promise<Scenario> => {
  const res = await axios.patch(`/ewosapi/v1/scenarios/gt2-multi/${scenarioId}/overview?globalSiteId=${globalSiteId}`, data);

  return res.data;
};

export const putScenarioFeedProgram = async (
  scenarioId: string,
  globalSiteId: string,
  data: UpdateScenarioFeedProgramInput
): Promise<any> => {
  const result = await axios.put(`/ewosapi/v1/scenarios/gt2-multi/${scenarioId}/feed-programs?globalSiteId=${globalSiteId}`, data);
  return result.data;
};

export const putFinanceData = async (
  scenarioId: string,
  globalSiteId: string,
  request: UpdateScenarioFinancialDataInput
): Promise<void> => {
  await axios.put(`/ewosapi/v1/scenarios/gt2-multi/${scenarioId}/financial-data?globalSiteId=${globalSiteId}`, request);
};
